<div
  [ngClass]="data.useLargeRoundedCorners ? 'tw-rounded-3xl' : 'tw-rounded-xl'"
  [style.background]="data.bodyBackground"
  class="tw-bg-color-surface-card tw-h-full tw-w-full tw-flex tw-flex-col"
>
  <modal-header
    [showBackButton]="data.showBackButton"
    [title]="data.rawTitle ?? (data.title | i18n: data.titleParam)"
    [showCloseButton]="showCloseButton"
    [customizedCloseIcon]="data.customizedCloseIcon"
    [useLargeRoundedCorners]="data.useLargeRoundedCorners"
    [plainCloseButton]="data.plainCloseButton"
    (onBackClicked)="handleBackClicked()"
  ></modal-header>
  <div
    appGlossScroll
    class="tw-flex tw-flex-col tw-justify-between tw-flex-1 tw-min-h-0 tw-overflow-y-auto"
  >
    <div [ngClass]="{ 'modal-body': !data.fullyCustomised }" class="tw-px-8 tw-pt-2">
      <ng-container *ngComponentOutlet="getComponent(); inputs: componentInputs"></ng-container>
    </div>

    @if (data.isInfoDialog) {
      <div class="tw-bg-color-surface-card tw-p-6">
        <app-gloss-button
          mat-dialog-close
          class="tw-w-40 sm:tw-w-full tw-bg-color-surface-card"
          [options]="{
            text: 'close' | i18n,
            class: 'neutral',
            isEnabled: true,
          }"
        ></app-gloss-button>
      </div>
    }
  </div>

  @if (data.footerTemplate) {
    <div class="tw-mt-auto tw-bg-color-surface-page tw-px-8 tw-rounded-b-3xl">
      <ng-container *ngTemplateOutlet="footerTemplate()"></ng-container>
    </div>
  }
</div>
